<div class="confirm">
	<label for="check" class="confirm__text"><ng-content></ng-content></label>
	<div class="confirm__box" [ngClass]="{ lineLeft: line }">
		<label class="switch" for="check">
			<input
				type="checkbox"
				id="check"
				[(ngModel)]="isCheckedTerms"
				(change)="checkTermsChange($event)"
			/>
			<span class="check"></span>
		</label>
	</div>
</div>
